import styled from 'styled-components';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 300px;
`;

export const InputGroup = styled.div`
`;

export const Footer = styled.div`
    display: flex;
    width: 100%;
    justify-content: space-between;
`;

export const Row = styled.div`
    display: flex;
    gap: 10px
`;